export function getAvaliacaoRedirectUrl(portalUrl, avaliePath, hash) {
    if (!portalUrl || !avaliePath || !hash) {
        return null;
    }
    return "".concat(portalUrl).concat(avaliePath, "/").concat(hash);
}
export function hasAvaliacaoConfig() {
    return Boolean(process.env.BASE_PATH_AVALIE &&
        process.env.AVALIE_SERVICE_ID &&
        process.env.AVALIE_ORGAO_ID &&
        process.env.AVALIE_PESQUISA_ID &&
        process.env.GOV_PI_AVALIE_URL &&
        process.env.PORTAL_URL);
}
